'use strict';

require('core/productDetail');
